import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CommonDialogNotificationComponent } from '../../../shared/common-dialog-notification/common-dialog-notification.component';
import { CommonDialogNotificationService } from '../../../shared/common-dialog-notification/common-dialog-notification.service';
import { DialogType } from '../../../shared/common-dialog-notification/common.dialog.model';
import { ConfirmationDialogNotificationService } from '../../../shared/confirmation-dialog/confirmation-dialog-notification.service';
import { LoaderService } from '../../../shared/loader/loader.service';
import { ReportingService } from '../../reporting.service';
import { ChangeStatusModel } from '../../admin-report/admin-report';
import { TransactionStatus } from '../transactionStatus.const';

@Component({
  selector: 'app-change-transaction-status-dialog',
  templateUrl: './change-transaction-status-dialog.component.html',
  styleUrls: ['./change-transaction-status-dialog.component.css']
})
export class ChangeTransactionStatusDialogComponent implements OnInit {

  transactionStatus : string[] = TransactionStatus;
  selectedStatus: string;
  remarks: string = "";

  constructor(
    public dialogRef: MatDialogRef<ChangeTransactionStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeStatusModel,
    private reportingService: ReportingService,
    private loaderService: LoaderService,
    private dialogService: CommonDialogNotificationService,
    private confirmationService: ConfirmationDialogNotificationService
  ) {
  }

  ngOnInit() {
    this.transactionStatus = this.transactionStatus.filter(status => status !== 'cancel');
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  changeStatus(paymentId, bankReferenceId) {

    this.confirmationService.open(null, null, () => {
      this.loaderService.show();
      let notificationDialogRef: MatDialogRef<CommonDialogNotificationComponent>;
      this.reportingService.updatePGTransactionStatus({transactionId: bankReferenceId, transactionStatus: this.selectedStatus, remarks: this.remarks}).subscribe(data => {
        this.loaderService.hide();
        if (data.response.toUpperCase() === 'SUCCESS') {
          notificationDialogRef = this.dialogService.open(DialogType.SUCCESS, data.message);

        } else {
          notificationDialogRef = this.dialogService.open(DialogType.FAILED, data.message);
        }
        notificationDialogRef.afterClosed().subscribe(() => {
          this.dialogRef.close(true);
        });
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/report/pg-detailed-transaction-report/change-transaction-status-dialog/change-transaction-status-dialog.component.ts